
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPersona"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonaInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPersona"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreCompleto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipoDocumento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nroDocumento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cuil"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sexo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nacionalidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaNacimiento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telefonos"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefono"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"origen"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"origen"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cbus"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cbu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descripcion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"origen"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"domicilios"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numero"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"piso"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"depto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"localidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"provincia"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"codigoPostal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"origen"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"documentos"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"agencia"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"idRapipago"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rotacionBloqueada"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jurisdiccion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idClienteColppy"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":929}};
    doc.loc.source = {"body":"mutation createPersona($input: PersonaInput){\n    createPersona(input: $input){\n        id\n        nombreCompleto\n        tipoDocumento\n        nroDocumento\n        cuil\n        sexo\n        nacionalidad\n        fechaNacimiento\n        telefonos {\n            telefono\n            tipo\n            origen\n        }\n        emails {\n            mail\n            tipo\n            origen\n        }\n        cbus {\n            cbu\n            descripcion\n            origen\n        }\n        domicilios {\n            tipo\n            calle\n            numero\n            piso\n            depto\n            localidad\n            provincia\n            codigoPostal\n            origen\n        }\n        documentos{\n            nombre\n            link\n        }\n        agencia{\n            id\n            nombre\n        }\n\n        idRapipago\n        estado\n        rotacionBloqueada\n        jurisdiccion\n        idClienteColppy\n    }\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["createPersona"] = oneQuery(doc, "createPersona");
        
